<template>
  <v-dialog
    v-model="dialog"
    :disabled="status === 'sent_to_unicia'"
    width="75%"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        class="LabelledDocument"
        :class="{ isError: isErrorState }"
        v-bind="attrs"
        v-on="on"
      >
        <div
          class="pic"
          :class="{
            empty: supportingDocuments.pages && supportingDocuments.pages.length === 0,
            readonly: status === 'sent_to_unicia',
          }"
        >
          <v-icon
            v-if="supportingDocuments.pages && supportingDocuments.pages.length === 0"
            color="#009ee0"
            x-large
          >
            mdi-plus
          </v-icon>

          <v-icon
            v-else
            :color="iconColor"
            x-large
          >
            {{ selectedIcon }}
          </v-icon>
        </div>
        <div
          class="text-truncate p p-bold label"
          :class="{
            required: required,
          }"
        >
          {{ label }}
        </div>
        <div
          v-if="addedOn"
          class="text-truncate text-uppercase h-5 mt-1 value"
        >
          {{ $t('common.addedOn', { date: addedOn }) }}
        </div>
        <div
          v-else
          class="text-truncate text-uppercase h-5 mt-1 value"
        >
          -
        </div>
      </div>
    </template>
    <v-card>
      <v-card-title
        :class="{
          'mt-16': $vuetify.breakpoint.xsOnly,
        }"
      >
        <div
          class="d-flex justify-space-between"
          style="width: 100%"
        >
          <div class="header d-flex flex-column">
            <span class="headline">{{ label }}</span>
            <span class="subtitle">{{ $t('main.documents.wording.subtitle') }}</span>
          </div>
          <!--@todo: check for use case on deleting a document -->
          <!-- <div
            v-if="Object.keys(supportingDocuments).length > 0"
            class="delete-btn"
          >
            <v-btn
              v-ripple="false"
              class="btn-wesave no-padding"
              text
              @click="deleteDocument(supportingDocuments.id)"
            >
              <v-img
                width="24"
                height="24"
                contain
                :src="imgsrc('icons', 'delete-red.svg')"
              />
            </v-btn>
          </div> -->
        </div>
      </v-card-title>
      <v-card-text>
        <v-row class="content">
          <v-col
            cols="12"
            md="7"
          >
            <div class="panel">
              <div class="input-title mb-2">
                {{ $t('main.documents.wording.input-title') }}
              </div>
              <v-file-input
                v-model="chosenFile"
                dense
                background-color="rgba(0, 158, 224, 0.06)"
                :hint="$t('main.documents.wording.hint')"
                :rules="rules"
                persistent-hint
                accept="image/png, image/jpeg, .pdf"
                filled
                outlined
                multiple
                prepend-icon=""
                prepend-inner-icon="mdi-file-document"
                class="mb-4"
              />
              <div
                v-for="(item, index) in supportingDocuments.pages"
                :key="item.id"
                class="uploadedFile d-flex justify-space-between my-2 align-center"
              >
                <div class="file-name d-flex align-center">
                  <div class="file-icon">
                    <v-img :src="imgsrc('icons', 'file-icon.svg')" />
                  </div>
                  {{ $t(`main.enums.documents.${supportingDocuments.document_kind}`) }}
                  <!-- <div class="file-creation-date mx-2">- {{ $d(new Date(item.created_at), 'short') }}</div> -->
                  <div class="file-creation-date mx-2">- {{ index + 1 }}</div>
                </div>
                <div class="file-delete">
                  <v-btn
                    v-ripple="false"
                    class="btn-wesave no-padding unset-min-width"
                    text
                    @click="deletePage(item.id)"
                  >
                    <img
                      alt=""
                      width="32"
                      height="32"
                      :src="'./assets/icons/close-blue.svg'"
                      class="picto"
                    />
                  </v-btn>
                </div>
              </div>
            </div>
          </v-col>

          <v-col
            md="5"
            cols="12"
          >
            <div class="panel mask">
              <div class="icon">
                <v-img :src="imgsrc('icons', 'protips_icon.svg')" />
              </div>
              <div class="title">
                {{ indicationTitle }}
              </div>
              <div
                v-if="['proof_of_address', 'proof_of_tax_address'].includes(type)"
                class="point choice"
              >
                {{ $t('main.documents.indications-points.choice') }}
              </div>
              <ul class="points-list">
                <li
                  v-for="(item, index) in indicationPoints"
                  :key="index"
                  class="point"
                >
                  {{ item }}
                </li>
                <li
                  v-if="type === 'tax_self_certification'"
                  class="point"
                >
                  {{ $t('main.documents.wording.pre-download') }}
                  <a
                    href="/files/fatca.pdf"
                    download
                  >{{ $t('main.documents.wording.download') }}</a>
                  {{ $t('main.documents.wording.post-download') }}
                </li>
              </ul>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex flex-column flex-md-row">
        <v-checkbox
          v-model="certifySelect"
          on-icon="done"
          off-icon=""
          color="#009ee0"
          :label="$t('common.certify-infos')"
          class="checkbox my-1 mr-2 button-purple ml-6"
          elevation="0"
        />
        <v-spacer />
        <div class="d-flex">
          <v-btn
            text
            class="theme-btn app-button-secondary color-white nice-padding mr-8"
            @click="dialog = false"
          >{{ $t('common.action.cancel') }}</v-btn>
          <v-btn
            :disabled="!certifySelect || status === 'sent_to_unicia'"
            text
            class="theme-btn app-button-primary color nice-padding"
            @click="uploadFile"
          >{{ $t('common.action.save') }}</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script type="text/javascript">
  import mixinDynImage from '@/mixins/utils/dynImage.js'
  import CommonMixin from '@/mixins/store/CommonMixin'
  import ApiService from '@/services/ApiService'

  export default {
    mixins: [CommonMixin, mixinDynImage,],
    props: {
      label: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: null,
      },
      status: {
        type: String,
        default: null,
      },
      creationDate: {
        type: String,
        default: null,
      },
      personId: {
        type: String,
        default: null,
      },
      supportingDocuments: {
        type: Object,
        required: true,
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        chosenFile: null,
        dialog: false,
        certifySelect: false,
        rules: [
          (files) =>
            !files || files.some((file) => file.size < 6_291_456) || 'Taille du fichier inférieur à 6 MO!',
        ],
        icons: {
          id_card: 'mdi-card-account-details-outline',
          proof_of_address: 'mdi-folder-home-outline',
          proof_of_tax_address: 'mdi-home-variant-outline',
          bank_account_identity: 'mdi-bank-outline',
          tax_self_certification: 'mdi-form-select',
          guardianship_document: 'mdi-file-document-outline',
          proxy_mandate: 'mdi-file-document-outline',
        },
        points: {
          id_card: 2,
          proof_of_address: 4,
          proof_of_tax_address: 3,
          bank_account_identity: 1,
          guardianship_document: 1,
          proxy_mandate: 1,
          tax_self_certification: 0,
        },
      }
    },
    computed: {
      isErrorState() {
        // eslint-disable-next-line no-prototype-builtins
        return this.formErrors.hasOwnProperty(this.type)
      },
      iconColor() {
        return this.isErrorState ? '#ff524f' : '#009ee0'
      },
      indicationTitle() {
        return this.$t(`main.documents.indications-titles.${this.type}`)
      },
      indicationPoints() {
        const tab = []
        for (let i = 1; i <= this.points[this.type]; i++) {
          tab.push(this.$t(`main.documents.indications-points.${this.type}_${i}`))
        }

        return tab
      },
      addedOn() {
        return this.creationDate && this.supportingDocuments.pages && this.supportingDocuments.pages.length > 0
          ? this.$d(new Date(this.creationDate), 'short')
          : null
      },
      selectedIcon() {
        return this.icons[this.type]
      },
    },
    methods: {
      // @todo: check for use case on deleting a document
      // async deleteDocument(id) {
      // this.toggleAppLoader(true)
      // const result = await ApiService.deleteDocument(id)
      // this.toggleAppLoader(false)
      // if (result.errors) {
      //   this.$message({
      //     type: 'error',
      //     text: 'file_delete_error',
      //   })
      // } else {
      //   this.$message({
      //     type: 'success',
      //     text: 'file_delete_success',
      //   })
      //   await this.refreshSelectedProfile(false)
      //   this.closeDialog()
      // }
      // },
      async deletePage(id) {
        this.toggleAppLoader(true)
        const result = await ApiService.deletePage(this.supportingDocuments.id, id)
        this.toggleAppLoader(false)
        if (result.errors) {
          this.$message({
            type: 'error',
            text: 'file_delete_error',
          })
        } else {
          this.$message({
            type: 'success',
            text: 'file_delete_success',
          })
          await this.refreshSelectedProfile(false)
        }
      },
      async uploadFile() {
        if (!this.chosenFile) {
          this.closeDialog()

          return
        }
        const formData = new FormData()
        for (var i = 0; i < this.chosenFile.length; i++) {
          const file = this.chosenFile[i]
          formData.append('supporting_documents[pages][]', file)
        }
        this.toggleAppLoader(true)
        let result = {}
        if (this.supportingDocuments.id) {
          result = await ApiService.addPages({ formData, id: this.supportingDocuments.id, })
        } else {
          formData.append('supporting_documents[person]', this.personId)
          formData.append('supporting_documents[document_kind]', this.type)
          result = await ApiService.createDocument(formData)
        }
        this.toggleAppLoader(false)
        if (result.data.attributes.status === 'uploaded') {
          this.$message({
            type: 'success',
            text: 'file_upload_success',
          })
          await this.refreshSelectedProfile(false)
          this.closeDialog()
        } else {
          this.$message({
            type: 'error',
            text: 'file_upload_error',
          })
        }
      },
      closeDialog() {
        this.dialog = false
        this.chosenFile = null
        this.certifySelect = false
      },
    },
  }
</script>

<style lang="scss" scoped>
/* stylelint-disable max-nesting-depth */
.LabelledDocument {
  cursor: pointer;
  &.isError {
    .pic {
      border: 2px solid $color-ff524f;
    }
    .label {
      color: $color-ff524f;
    }
  }
  .pic {
    display: flex !important;
    justify-content: center;
    width: 12rem;
    height: 12rem;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgb(31 54 139 / 8%);
    border: 2px solid $color-d5e4f3;
    &.empty {
      border: 2px dashed $color-d5e4f3;
    }
    &.readonly {
      cursor: not-allowed;
    }
    &.readonly:hover {
      background-color: $color-0_158_224_8;
      background-image: url('../../../assets/icons/check.svg');
      background-position: right 5% top 5%;
      background-repeat: no-repeat;
    }
    &:not(.empty):not(.readonly):hover {
      background-color: $color-0_158_224_8;
      background-image: url('../../../assets/icons/edit.svg');
      background-position: right 5% top 5%;
      background-repeat: no-repeat;
    }
  }
  text {
    user-select: none;
    alignment-baseline: hanging;
  }

  .label {
    margin-top: 0.5rem;
    font-size: 1rem;
    color: $color-009ee0;
    &.required::after {
      content: '*';
    }
  }
  .value {
    font-size: 0.8rem;
    color: $color-9e9fa2;
  }
  .non-available {
    color: $color-49495c;
  }
}
.content {
  border: 2px solid rgba(121, 137, 183, 0.08);
  border-radius: 5px;
  margin: 2rem 2rem 4rem 2rem !important;
  .panel {
    padding: 2rem;
    &.mask {
      height: 100%;
      box-sizing: border-box;
      border: 2px solid $color-f5f6fa;
      border-radius: 0 5px 5px 0;
      background-color: $color-fafbff;
      background-image: url('../../../assets/icons/protips_bg.svg');
      background-position: right -20% top -20%;
      background-size: 65%;
    }
    .icon {
      width: 80px;
      height: 80px;
    }
    .title {
      margin-top: 3rem;
      font-size: 1.5rem;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 2rem;
      color: $color-001c4b;
    }
    ul {
      margin: 0;
      &.points-list {
        list-style-type: none;
        margin-top: 0.5rem;
        margin-bottom: 5rem;

        > li {
          text-indent: -5px;
        }

        > li:before {
          content: '-';
          text-indent: -5px;
        }

        .point {
          font-size: 0.8rem;
          letter-spacing: 0.21px;
          line-height: 1.4rem;
          color: $color-202122;
          &.choice {
            font-weight: 600;
          }
        }
      }
    }

    .input-title {
      font-size: 0.9rem;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 1.4rem;
      color: $color-102d69;
    }
    .uploadedFile {
      padding: 0.5rem 1rem;
      border-radius: 5px;
      background-color: $color-0_158_225_08;
      .file-name {
        color: $color-009ee0;
        font-size: 0.9rem;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 1.4rem;
        .file-icon {
          margin-right: 1rem;
          width: 2rem;
        }
        .file-creation-date {
          font-size: 0.8rem;
          line-height: 1rem;
        }
      }
    }
  }
}
.delete-btn {
  float: right;
}
.header {
  .headline {
    font-size: 2em;
    font-weight: 600;
    color: $color-001c4b;
  }
  .subtitle {
    font-size: 1em;
    font-weight: 500;
    color: $color-4d4d4f;
  }
}
.v-card.v-sheet {
  border-radius: 8px;
  background-color: $color-ffffff;
  box-shadow: 0 7px 64px 0 rgba(0, 0, 0, 0.07) !important;
  .v-card__title,
  .v-card__actions {
    border-radius: 8px 8px 0 0;
    background-color: $color-fafbff;
    box-shadow: inset 0 -1px 0 0 rgba(121, 137, 183, 0.16);
    padding: 2rem;
  }
  .v-card__actions {
    box-shadow: inset 0 1px 0 0 rgba(121, 137, 183, 0.16);
  }
}
.v-file-input {
  .v-input__control {
    .v-input__slot {
      fieldset {
        border: 1.4px dashed $color-009ee0;
      }
    }
  }
}
.col {
  padding: unset;
}
</style>
